import { Row, Space, Button, Badge, Menu, Dropdown, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { getBranchList, getMachineList } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { UpdateMachineList } from '../../redux/reducers/machinelistSlice';
import { useNavigate } from 'react-router-dom';
import { DownOutlined, EditFilled, DeleteFilled, TagFilled } from '@ant-design/icons';
import _ from "lodash";
import { NewBranchOfficeDialog } from './NewBranchOfficeDialog';
import { AssignUserDialog } from './AssignUserDialog';
import { AssignStateDialog } from './AssignStateDialog';
import {
    UserSwitchOutlined,
    GlobalOutlined,
    EditOutlined,
    DeleteOutlined,
  } from "@ant-design/icons";

const BranchOffice = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const [filteredData, setFilteredData] = useState([]);
    const [showNewBranchOfficeDialog, setShowNewBranchOfficeDialog] = useState(false);
    const [newBranchOfficePayload, setNewBranchOfficePayload] = useState({ branchOfficeId: 0, mode: 0,branchOfficeName:'',branchOfficeDesc:'' });
    const [assignUserPayload, setAssignUserPayload] = useState({ branchOfficeId: 0 });
    const [showAssignUserDialog, setShowAssignUserDialog] = useState(false);
    const [assignStatePayload, setAssignStatePayload] = useState({ branchOfficeId: 0 });
    const [showAssignStateDialog, setShowAssignStateDialog] = useState(false);

    const columns: ColumnsType<any> = [
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        { title: 'نام نمایندگی', dataIndex: 'str_BranchOfficeName', key: 'str_BranchOfficeName' },
        { title: 'توضیحات', dataIndex: 'str_Description', key: 'str_Description' },
    ];

    const menu = (record: any) => (
        <Menu
          items={[
            {
              key: "1",
              label: "انتصاب به کاربر",
              onClick: () => assignUserOnClick(record.prk_BranchOfficeAutoID),
              icon: <UserSwitchOutlined />,
            },
            {
              key: "2",
              label: "انتصاب به استان",
              onClick: () => assignStateOnClick(record.prk_BranchOfficeAutoID),
              icon: <GlobalOutlined />,
            },
            {
              key: "3",
              label: "ویرایش",
              onClick: () => editOfficeOnClick(record),
              icon: <EditOutlined />,
             },
            // {
            //   key: "4",
            //   label: "حذف",
            //   onClick: () => removeOnClick(record.prk_BranchOfficeAutoID),
            //   icon: <DeleteOutlined />,
            // },
          ]}
        />
      );


    useEffect(() => {

        loadBranches();
        // if(myStore.auth.loginType === 'parsicuser')
        // { 
        //     myStore.auth.permission.map((item:any)=>{   
        //     if(item.pageName == 'Machine')
        //         setPermission(item.isDetailAccess);
        //     });
        // }
        // else{
        //     setPermission(true);
        // }
    }, [])

    const loadBranches = () => {
        getBranchList()
            .then((result: any) => {
                dispatch(UpdateMachineList({ machineList: result.data.data }))
                setFilteredData(result.data.data)
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                // TODO: notify by toast
            })
    }

    const addNewOnClick = () => {
        setNewBranchOfficePayload(() => ({
            branchOfficeId:0,
            branchOfficeName: '',
            branchOfficeDesc:'',
            mode: 0
        }));
        setShowNewBranchOfficeDialog(true);
    }

    const editOfficeOnClick = (record:any) => {
        setNewBranchOfficePayload(() => ({
            branchOfficeId:record.prk_BranchOfficeAutoID,
            branchOfficeName: record.str_BranchOfficeName,
            branchOfficeDesc:record.str_Description,
            mode: 1
        }));
        setShowNewBranchOfficeDialog(true);
    }

    const assignUserOnClick = (id: number) => {
        setAssignUserPayload((values: any) => ({
            ...values,
            branchOfficeId: id,
            mode: 0
        }));
        setShowAssignUserDialog(true);
    }
    const assignStateOnClick = (id: number) => {
        setAssignStatePayload((values: any) => ({
            ...values,
            branchOfficeId: id,
            mode: 0
        }));
        setShowAssignStateDialog(true);
    }


    return (
        <>
            <Row>
                <CustomTable columns={columns} data={filteredData} isloading={isLoading}
                    onAddClick={addNewOnClick} permission={true} />
            </Row>
            <NewBranchOfficeDialog
                visible={showNewBranchOfficeDialog}
                onSubmit={() => console.log(true)}
                onCancel={() => { setShowNewBranchOfficeDialog(false); loadBranches() }}
                payLoad={newBranchOfficePayload}
                setShowDialog={() => { setShowNewBranchOfficeDialog(false); loadBranches() }}
            />
            <AssignUserDialog
                visible={showAssignUserDialog}
                onSubmit={() => console.log(true)}
                onCancel={() => { setShowAssignUserDialog(false); loadBranches() }}
                payLoad={assignUserPayload}
                setShowDialog={() => { setShowAssignUserDialog(false); loadBranches() }}
            />

            <AssignStateDialog
                visible={showAssignStateDialog}
                onSubmit={() => console.log(true)}
                onCancel={() => { setShowAssignStateDialog(false); loadBranches() }}
                payLoad={assignStatePayload}
                setShowDialog={() => { setShowAssignStateDialog(false); loadBranches() }}
            />
        </>
    );
}


export default BranchOffice;